var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentPrimaryUserIcon = function SvgCommentPrimaryUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M18 22.76c6.508 0 12 1.058 12 5.138C30 31.98 24.472 33 18 33c-6.506 0-12-1.058-12-5.138 0-4.081 5.528-5.101 12-5.101M18 3a7.91 7.91 0 0 1 7.941 7.937A7.91 7.91 0 0 1 18 18.875a7.91 7.91 0 0 1-7.941-7.938A7.91 7.91 0 0 1 18 3"
  })));
};
export default SvgCommentPrimaryUserIcon;